import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Checkbox, Form, Input, Popover, Select, Tag } from 'antd';
import { ChevronDown, ChevronUp, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

const SellOrder = React.forwardRef((props, ref) => {
  const {
    setNumberOfShare,
    duration,
    setDuration,
    userPurchasedShare,
    numberOfShare,
    limitPrice,
    setLimitPrice,
    LowestAskPrice,
    quickBuyPropertyData,
    totalInvestment,
    transactionFee,
    totalPurchase,
    partialFills,
    setPartialFills,
  } = props;
  const [arrowUpDuration2, setArrowUpDuration2] = useState(false);
  const [expandAdvanced, setExpandAdvanced] = useState(true);
  const [isTextSelected, setIsTextSelected] = useState(false);
  return (
    <div className='buy-content'>
      <Form ref={ref} form={ref?.current}>
        {/* === No Shares Notice === */}
        {userPurchasedShare <= 0 ? (
          <div className='py-40 no-share'>
            <p className='fz-14 text-center mb-8'>No shares to sell</p>
            <p className='fz-12 text-taupe-80'>
              You currently do not own any shares of this property. If you would like to participate on the{' '}
              <Link to='/market/secondary'>Realbricks Market</Link>, please consider purchasing shares in the Buy tab.
            </p>
          </div>
        ) : (
          <>
            <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare}>
              <Form.Item
                className='mb-12 mt-42'
                validateStatus={(numberOfShare > userPurchasedShare || Number(numberOfShare) % 1 !== 0) && 'error'}
                help={
                  Number(numberOfShare) % 1 !== 0
                    ? 'Decimal numbers are not allowed.'
                    : numberOfShare > userPurchasedShare && `You have exceeded the sell out limit.(i.e more than ${userPurchasedShare} shares)`
                }
              >
                <Input
                  type='number'
                  onWheel={(e) => {
                    e.target.blur();
                  }}
                  controls={false}
                  value={numberOfShare}
                  onChange={(e) => setNumberOfShare(e.target.value.replace(/[^0-9]/g, ''))}
                  onSelect={(e) => {
                    window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
                  }}
                  onKeyPress={(event) => {
                    if ((!/[0-9]/.test(event.key) || Number(numberOfShare) > Number(userPurchasedShare)) && !isTextSelected) {
                      event.preventDefault();
                    }
                  }}
                  id='share'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-20 buy-tags'>
              <Tag
                className={numberOfShare?.toString() === userPurchasedShare.toString() && 'ant-tag__selected'}
                onClick={() => setNumberOfShare(userPurchasedShare.toString() || '0')}
              >
                {`all: ${userPurchasedShare || 0}`}
              </Tag>
            </div>
            <FloatingLabel label='Limit price' inputId='shares' inputValue={limitPrice}>
              <Form.Item
                className='mb-12'
                validateStatus={limitPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice) && 'error'}
                help={
                  limitPrice && !/^(?!0\d)(\d+(?:\.\d{1,2})?)$/.test(limitPrice) && 'Please enter a number grater then 0 and upto 2 decimal places.'
                }
              >
                <Input
                  value={limitPrice}
                  onChange={(e) => setLimitPrice(e.target.value.replace(/[^0-9 .]/g, ''))}
                  placeholder='$'
                  onKeyPress={(event) => {
                    if (!/[0-9 .]/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                      event.preventDefault();
                    }
                  }}
                  id='limit'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-20 buy-tags'>
              <Tag
                className={
                  Number(LowestAskPrice) <= 0 ? 'ant-tag-disabled' : limitPrice?.toString() === LowestAskPrice?.toString() && 'ant-tag__selected'
                }
                onClick={() => Number(LowestAskPrice) > 0 && setLimitPrice(LowestAskPrice?.toString() || '0')}
              >
                {`Best ask: $${getUsCurrencyFormat(LowestAskPrice || 0)} `}
              </Tag>
              <Tag
                className={limitPrice?.toString() === quickBuyPropertyData?.lastTradedPrice?.toString() && 'ant-tag__selected'}
                onClick={() => setLimitPrice(quickBuyPropertyData?.lastTradedPrice?.toString() || '0')}
              >
                {`Last price: $${getUsCurrencyFormat(quickBuyPropertyData?.lastTradedPrice || 0)}`}
              </Tag>
            </div>
            <FloatingLabel label='Duration' inputId='duration' inputValue={duration}>
              <>
                <div id='duration2-anchor' />
                <Form.Item className='mb-12' name='duration'>
                  <Select
                    id='duration'
                    popupClassName='filter-select-dropdown'
                    onChange={(value) => setDuration(value)}
                    value={duration}
                    defaultValue={duration}
                    getPopupContainer={() => document.getElementById('duration2-anchor')}
                    onDropdownVisibleChange={() => setArrowUpDuration2(!arrowUpDuration2)}
                    suffixIcon={arrowUpDuration2 ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  >
                    <Select.Option value='Good Until Cancel'>Good until cancel</Select.Option>
                    <Select.Option value='Good For The Day'>Good for the day</Select.Option>
                  </Select>
                </Form.Item>
              </>
            </FloatingLabel>
            <div className='mb-40 basic-info'>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Total investment (USD)</span>
                <span className='basic-info__item__value fw-600'>{`$${getUsCurrencyFormat(totalInvestment || 0)}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Platform fee</span>
                <span className='basic-info__item__value'> $2.50</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Broker-Dealer/ATS Fee (1%)</span>
                <span className='basic-info__item__value'> {`$${transactionFee || ''}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name underline'>Total purchase (USD)</span>
                <span className='basic-info__item__value'>{`$${totalPurchase || ''}`}</span>
              </div>
              {numberOfShare && limitPrice && totalPurchase <= 0 && (
                <span className='text-error fz-14'>Total purchase price should be greater than 0.</span>
              )}
            </div>
            <div className='mb-40 mt-20 fz-16'>
              <p className='fw-600 mb-8 cursor-pointer' onClick={() => setExpandAdvanced(!expandAdvanced)}>
                Advanced {expandAdvanced ? <ChevronUp verticalAlign='-7px' /> : <ChevronDown verticalAlign='-7px' />}
              </p>
              {!!expandAdvanced && (
                <div className='options'>
                  <Checkbox checked={partialFills} onChange={(e) => setPartialFills(e.target.checked)} className='fz-16'>
                    Accept partial fills
                    <Popover
                      placement='bottom'
                      popupClassName='div-yeild-pop'
                      content='Allow for your order to be filled in segments by smaller buyers. Doing this will give you the ability to start trading owned shares right away. Unfilled shares will be cancelled at the selected duration. '
                      trigger='hover'
                    >
                      <span>
                        <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                      </span>
                    </Popover>
                  </Checkbox>
                </div>
              )}
            </div>
          </>
        )}
      </Form>
    </div>
  );
});

export default SellOrder;
